<p-toast position="bottom-center" class="app-toast">
  <ng-template let-message let-closeFn="closeFn" pTemplate="headless">
    @if (message.data?.kind === 'menuCatalogImportFailure') {
      <div
        class="app-toast-card app-toast-card--error"
        role="alert"
        aria-live="polite"
        aria-atomic="true"
      >
        <div class="app-toast-card__header">
          <div class="app-toast-card__title">
            {{ message.summary || message.detail }}
          </div>
          @if (message.closable !== false) {
            <button
              type="button"
              class="app-toast-card__dismiss"
              (click)="closeFn($event)"
            >
              Dismiss
            </button>
          }
        </div>

        @if (message.detail) {
          <div class="app-toast-card__message">{{ message.detail }}</div>
        }

        @if (message.data?.issues?.length) {
          <div
            class="app-toast-card__issues"
            [class.app-toast-card__issues--scroll]="isExpanded(message)"
            aria-label="Row issues"
          >
            @for (
              issue of (isExpanded(message) ? message.data.issues : message.data.issues.slice(0, 5));
              track issue.rowNumber
            ) {
              <div class="app-toast-card__issue">
                <span class="app-toast-card__issue-row">Row {{ issue.rowNumber }}</span>
                <span class="app-toast-card__issue-text">{{ issue.message }}</span>
              </div>
            }
            @if (message.data.issues.length > 5 && !isExpanded(message)) {
              <button
                type="button"
                class="app-toast-card__issue-more"
                (click)="showAllIssues(message)"
              >
                +{{ message.data.issues.length - 5 }} more row(s)
              </button>
            }
          </div>
        }
      </div>
    } @else {
    <div
      class="app-toast-banner"
      [class.app-toast-banner--success]="message.severity === 'success'"
      [class.app-toast-banner--error]="message.severity === 'error'"
      [class.app-toast-banner--warn]="message.severity === 'warn'"
      [class.app-toast-banner--info]="message.severity === 'info' || !message.severity"
      role="alert"
      aria-live="polite"
      aria-atomic="true"
    >
      <p class="app-toast-banner__text">
        {{ message.detail || message.summary }}
      </p>
      @if (message.closable !== false) {
        <button
          type="button"
          class="app-toast-banner__action app-toast-banner__action--accept"
          (click)="closeFn($event)"
        >
          Dismiss
        </button>
        <button
          type="button"
          class="app-toast-banner__action app-toast-banner__action--close"
          aria-label="Dismiss"
          (click)="closeFn($event)"
        >
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      }
    </div>
    }
  </ng-template>
</p-toast>